import { Text } from "@/components/Text";
import { TableBody, TableCell, TableRow } from "@/components/ui/table";

import { formatting } from "@/lib/formatting";
import { cn } from "@/lib/utils";

// Mirrors the table's <colgroup> so the totals line up under their columns.
export const EarningsTrackerTotalsFooter = ({
  columnWidths,
  isDisabled,
  totalCommission,
  totalRevenue,
}: {
  columnWidths: string[];
  isDisabled: boolean;
  totalCommission: number;
  totalRevenue: number;
}) => {
  /* Render */
  const render = () => (
    <div className="sticky bottom-0 z-20 rounded-b-lg border border-t-0 border-slate-200 bg-slate-50">
      <table className="w-full table-fixed border-separate border-spacing-0 text-sm">
        <colgroup>
          {columnWidths.map((width, index) => (
            <col key={index} style={{ width }} />
          ))}
        </colgroup>
        <TableBody>
          <TableRow className="h-24 border-0 hover:bg-transparent">
            <TableCell className="px-4 py-0">
              <Text className="text-sm font-medium text-slate-900">Total</Text>
            </TableCell>
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell className="px-4 py-0">
              <Text
                className={cn(
                  "text-xl font-semibold tabular-nums leading-none",
                  isDisabled ? "text-slate-400" : "text-slate-900/80",
                )}
              >
                {formatting.currency(totalRevenue)}
              </Text>
            </TableCell>
            <TableCell className="px-4 py-0">
              <Text
                className={cn(
                  "text-xl font-semibold tabular-nums leading-none",
                  isDisabled ? "text-slate-400" : "text-green-700",
                )}
              >
                {formatting.currency(totalCommission)}
              </Text>
            </TableCell>
            <TableCell />
            <TableCell />
            <TableCell />
          </TableRow>
        </TableBody>
      </table>
    </div>
  );

  return render();
};
